import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash-es';
import moment from 'moment';

@Component({
    selector: 'recap-applicant',
    templateUrl: './recap-applicant.component.html',
    styleUrls: ['./recap-applicant.component.scss'],
    standalone: false
})
export class RecapApplicantComponent implements OnInit {
    /**
     * Perform address matching on applicants
     *
     * @type {boolean}
     * @memberof RecapComponent
     */
    @Input() doAddressMatch: boolean = false;

    /**
     * flag to indicate if address match already done or not
     * @type {boolean}
     * @memberof RecapApplicantComponent
     */
    @Input() addressMatchDoneAlready: boolean = false;

    /**
     * Applicant
     * @memberof RecapApplicantComponent
     */
    @Input() applicant;

    /**
     *
     *
     * @type {EventEmitter<boolean>}
     * @memberof RecapApplicantComponent
     */
    @Output() allAddressesMatched: EventEmitter<boolean>
        = new EventEmitter<boolean>();

    /**
     * Output for address matches array.
     *
     * @type {EventEmitter<FormArray>}
     * @memberof RecapApplicantComponent
     */
    @Output() outputApplicant: EventEmitter<UntypedFormGroup> =
        new EventEmitter<UntypedFormGroup>();

    /**
     * Formarray containing address matches, numbered by their iterator.
     *
     * @type {FormArray}
     * @memberof RecapApplicantComponent
     */
    addressMatches: UntypedFormArray = new UntypedFormArray([]);

    /**
     * The detail for this applicant.
     *
     * @type {FormGroup}
     * @memberof RecapApplicantComponent
     */
    applicantDetail: UntypedFormGroup = new UntypedFormGroup({
        applicantIterator: new UntypedFormControl(null, []),
        addressMatches: this.addressMatches,
    });


    /**
     * Getter for the applicant iterator.
     *
     * @readonly
     * @memberof RecapApplicantComponent
     */
    get applicantIterator() {
        if (_.isNil(this.applicant)) {
            return null;
        }
        return this.applicant.ApplicantSequence;
    }

    /**
     * Getter for DOB value.
     *
     * @readonly
     * @memberof RecapApplicantComponent
     */
    get DateOfBirth() {
        return moment(_.defaultTo(this.applicant['DateOfBirth'], '')).format('DD/MM/YYYY');
    }


    /**
     * Outputs the form to the parent.
     *
     * @memberof RecapApplicantComponent
     */
    outputToParent() {
        this.outputApplicant.emit(this.applicantDetail);
    }

    /**
     * Takes an address match from the recap-applicant-address component.
     *
     * @param {any} match
     * @memberof RecapApplicantComponent
     */
    takeAddressMatchObject(match) {
        const iterator = match.iterator;
        const address = match.address;
        const applicantIterator = match.applicant;
        this.applicantDetail.get('applicantIterator').setValue(this.applicantIterator);
        this.addressMatches.setControl(iterator, address);
        this.applicantDetail.setControl('addressMatches', this.addressMatches);
        this.outputToParent();
    }

    /**
     * Initialise
     *
     * @memberof RecapApplicantComponent
     */
    ngOnInit() {
        if (_.isNil(this.applicant)) {
            return;
        }
        this.applicantDetail.get('applicantIterator').setValue(this.applicant.ApplicantSequence);
    }

}
